import { render, staticRenderFns } from "./collbaorateRulesDrawer.vue?vue&type=template&id=59245a80&scoped=true"
import script from "./collbaorateRulesDrawer.vue?vue&type=script&lang=js"
export * from "./collbaorateRulesDrawer.vue?vue&type=script&lang=js"
import style0 from "./collbaorateRulesDrawer.vue?vue&type=style&index=0&id=59245a80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59245a80",
  null
  
)

export default component.exports